import React from 'react'
import Nav from '../components/Nav'
import Body from '../components/Body'
import Footer from '../components/Footer'
import '../styles/globals.css'

const App: React.FC = () => {
  return (
    <>
      <Nav />
      <Body />
      <Footer />
    </>
  )
}

export default App